import { useEffect, useState } from 'react';
import Landing from '@/pages/Landing';
import Conversation from '@/pages/Conversation';
import Wizard from '@/pages/Wizard';
import Sitio from '@/pages/Sitio';
import Corredor from '@/pages/Corredor';
import Matriz from '@/pages/Matriz';
import { resetSession, session } from '@/engine/store';

// Último caso abierto: la sesión se evalúa solo al cambiar de caso, nunca en cada render
let ultimoCaso = null;
import { marcaFromHash, applyMarcaCss } from '@/engine/marcas';

function useHash() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const fn = () => setHash(window.location.hash);
    window.addEventListener('hashchange', fn);
    return () => window.removeEventListener('hashchange', fn);
  }, []);
  return hash;
}

// Routing landing <-> wizard <-> conversación
// Atajos: #J1 wizard · #J1-auto wizard automático → caso A · #A caso A · #A-auto automático
export default function App() {
  const hash = useHash();

  // Marca GLOBAL: aplica --marca/data-marca en <html> en toda ruta (hash o localStorage).
  useEffect(() => { applyMarcaCss(); }, [hash]);

  // B2B2C: micrositio multimarca y vista del corredor (mismo motor y catálogo).
  if (hash.startsWith('#sitio')) {
    return <Sitio key={hash} marca={marcaFromHash(hash)} />;
  }
  if (hash.startsWith('#matriz')) return <Matriz />;
  if (hash.startsWith('#corredor')) {
    return <Corredor key={hash} marca={marcaFromHash(hash)} />;
  }

  if (hash.startsWith('#J1')) {
    const auto = hash.includes('auto');
    return (
      <Wizard
        key={hash}
        auto={auto}
        onHome={() => { resetSession(); window.location.hash = ''; }}
      />
    );
  }
  if (hash.startsWith('#wa-retoma')) {
    return <Conversation key="waretoma" resume wa onHome={() => { window.location.hash = ''; }} />;
  }
  if (hash.startsWith('#wa')) {
    return <Conversation key="wa" caseId="A" wa onHome={() => { window.location.hash = ''; }} />;
  }
  if (['#A', '#B', '#C', '#V', '#S'].some((h) => hash.startsWith(h))) {
    const auto = hash.includes('auto');
    const caseId = hash[1]; // A · B · C
    // QA 16-oct: un caso solo hereda el recorrido inicial si viene de ESE momento (evita mezclar seguros)
    if (hash !== ultimoCaso) {
      ultimoCaso = hash;
      if (!(session.fromJ1 && session.lead && session.lead.go === caseId)) resetSession();
    }
    return <Conversation key={hash} caseId={caseId} auto={auto} onHome={() => { window.location.hash = ''; }} />;
  }
  return (
    <Landing
      onStart={(target) => {
        resetSession();
        window.location.hash = target;
      }}
    />
  );
}
